import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import BlogThumbnail from "../components/BlogThumnail";
import imgg from "./content/pics/modernvanvas.jpeg";
import Articles from "./Articles";
import MovieReviews from "./MovieReviews";
import ShortStories from "./ShortStories";
import "./content.css";
import Na from "./content/pics/g.png";
import bum from "./content/pics/bumble.jpg";
import mys from "./content/pics/mysore.jpg";
import mum from "./content/pics/mumbai.jpeg";
import bum2 from "./content/pics/bumble2.jpeg";
import ord from "./content/pics/ordinary.jpeg";
import vol from "./content/pics/volun.jpg";
import fem from "./content/pics/feminism.png";
import que from "./content/pics/questions.jpg";
import math from "./content/pics/Matheeww.jfif";
import anx from "./content/pics/anxiety.jpg";
import ps from "./content/pics/ps.jpg";
import jou from "./content/pics/journal.jpg"
import ram from "./content/pics/ram.webp"
const Content = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState("all");
  const [isSticky, setIsSticky] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div className={`Full ${isSticky ? "sticky" : ""}`}>
      <div className="all">
      <div className="filler"/>
        <div className="sidebar">
          <button className={`toggle-button ${isOpen ? "open" : ""}`} onClick={toggleSidebar}>
            <div className={`hamburger-icon ${isOpen ? "close" : ""}`}>
              <span className="line"></span>
              <span className="line"></span>
              <span className="line"></span>
            </div>
          </button>
          <Sidebar isOpen={isOpen} selectedItem={selectedItem} setSelectedItem={setSelectedItem} />
        </div>
        <div className="main-content">
          <div className="links-containerc">
            <a href="/">Home</a>
            <a href="/content">Content</a>
            <a href="/aboutus">About Us</a>
          </div>
          </div>
          <div className="thumbnails">
          <div className="seventh-blog-thumbnail-container">
          <a href="/ram">
              <BlogThumbnail
                imageSrc={ram}
                title="The Epic Journey of the Ram Mandir: Unveiling Centuries of Faith and Heritage"
                description="No offense, what's happening on 22nd January?"
              />
            </a>
          </div>

          <div className="seventh-blog-thumbnail-container">
          <a href="/journal">
              <BlogThumbnail
                imageSrc={jou}
                title="Dear Diary"
                description="No offense, but diary is the most loyal companion"
              />
            </a>
          </div>

          <div className="seventh-blog-thumbnail-container">
          <a href="/phaseshift">
              <BlogThumbnail
                imageSrc={ps}
                title="Phaseshift is here."
                description="No offense, but if you're not at Phaseshift, then you're missing out."
              />
            </a>
          </div>

          
          <div className="seventh-blog-thumbnail-container">
          <a href="/anxiety">
              <BlogThumbnail
                imageSrc={anx}
                title="Let's talk about mental health."
                description="No offense, but anxiety is REAL."
              />
            </a>
          </div>

            
          <div className="seventh-blog-thumbnail-container">
          <a href="/mathew">
              <BlogThumbnail
                imageSrc={math}
                title="Matthew Perry: The Laughter, The Struggles, and The Legacy of Chandler Bing"
                
              />
            </a>
          </div> 


          {/* <div className="seventh-blog-thumbnail-container">
          <a href="/questions">
              <BlogThumbnail
                imageSrc={que}
                title="Let's talk about sex."
                description="No offense, but these questions need to be answered."
              />
            </a>
          </div>  */}

          <div className="seventh-blog-thumbnail-container">
          <a href="/feminism">
              <BlogThumbnail
                imageSrc={fem}
                title="The future is not female"
                description="No offense, but no gender can be the future."
              />
            </a>
          </div> 

          <div className="seventh-blog-thumbnail-container">
          <a href="/volun">
              <BlogThumbnail
                imageSrc={vol}
                title="Being the change at U and I"
                description="No offense, but volunteering can truly be a life-changing experience"
              />
            </a>
          </div> 


          <div className="seventh-blog-thumbnail-container">
          <a href="/ordinary">
              <BlogThumbnail
                imageSrc={ord}
                title="Ordinary is Extraordinary"
                description="No offense, but ordinary is extraordinary."
              />
            </a>
          </div> 

          <div className="sixth-blog-thumbnail-container">
          <a href="/bumble2">
              <BlogThumbnail
                imageSrc={bum2}
                title="Love On a Bumble Lane: Part-2"
                description="No offense, but where the hell is Daksh?"
              />
            </a>
          </div>  


          <div className="fifth-blog-thumbnail-container">  <a href="/mumbai">
    <BlogThumbnail
      imageSrc={mum}
      title="Mumbai-Travel Blog"
      description="No offense, but Mom and I in Mumbai; Unraveling the Charms of the City Together"
    />
  </a>

</div>

          <div className="fourth-blog-thumbnail-container">  <a href="/mysore">
    <BlogThumbnail
      imageSrc={mys}
      title="Mysore"
      description="No offense, but sometimes you need to run away from your problems."
    />
  </a>

</div>
           
          <div className="third-blog-thumbnail-container"> {/* New container for the second blog thumbnail */}
            <a href="/bumble">
              <BlogThumbnail
                imageSrc= {bum}
                title="Love on a Bumble Lane"
                description="No offense, but anything can happen with just one swipe. Is it love, or a lesson?"
              />
            </a>
          </div>
          <div className="second-blog-thumbnail-container">
          <a href="/modernvanvas">
              <BlogThumbnail
                imageSrc={imgg}
                title="Modern Vanvas"
                description="No offense, but you're getting sucked in an online black hole. 
                We've all gotten addicted to social media at some point to avoid facing reality. Is there any way out of it?"
              />
            </a>
          </div>
          <div className="blog-thumbnail-container">
          <a href="/ninhaB_VS_nanhaB">
              <BlogThumbnail
                imageSrc={Na}
                title="Nanna Bengaluru VS Ninna Bengaluru"
                description="No offense, but Bengaluru is a double-edged sword. Does it embrace you, or suffocate you?"
              />
            </a>
          </div>
         
</div>

        </div>
      </div>
  
  );
};

export default Content;
